export default {
  hljs: {
    display: 'block',
    overflowX: 'auto',
    padding: '24px 16px',
    background: '#B1D2F3',
    color: '#000033',
    'border-radius': '10px',
  },
  'hljs-string': {
    color: '#6D82AA',
  },
  'hljs-variable': {
    color: '#93AFD3',
  },
  'hljs-template-variable': {
    color: '#93AFD3',
  },
  'hljs-symbol': {
    color: '#93AFD3',
  },
  'hljs-bullet': {
    color: '#93AFD3',
  },
  'hljs-section': {
    color: '#93AFD3',
    fontWeight: 'bold',
  },
  'hljs-addition': {
    color: '#93AFD3',
  },
  'hljs-attribute': {
    color: '#93AFD3',
  },
  'hljs-link': {
    color: '#93AFD3',
  },
  'hljs-comment': {
    color: '#93AFD3',
  },
  'hljs-number': {
    color: '#93AFD3',
  },
  linenumber: {
    color: '#93AFD3',
  },
  'hljs-quote': {
    color: '#93AFD3',
  },
  'hljs-meta': {
    color: '#93AFD3',
  },
  'hljs-deletion': {
    color: '#93AFD3',
  },
  'hljs-keyword': {
    fontWeight: 'bold',
  },
  'hljs-selector-tag': {
    fontWeight: 'bold',
  },
  'hljs-name': {
    fontWeight: 'bold',
  },
  'hljs-type': {
    fontWeight: 'bold',
  },
  'hljs-strong': {
    fontWeight: 'bold',
  },
  'hljs-emphasis': {
    fontStyle: 'italic',
  },
};
